<template>
  <v-tooltip
    bottom
    content-class="tooltip black--text">
    <template #activator="{ on }">
      <div
        class="flex flex-wrap"
        v-on=" urgent && item && item.urgentReason ? on : ''">
        <sIcon
          v-if="urgent"
          class="my-auto mr-1"
          color="var(--color-error)"
          size="8"
          type="dot"/>
        <span v-dompurify-html="formatAppDateTo( date_item ) "/>
      </div>
    </template>
    {{ item && item.urgentReason }}
  </v-tooltip>
</template>
<script>
import { filterSortMixin } from 'mixins'
export default {
  name: 'dateSpan',
  mixins: [ filterSortMixin ],
  props: {
    items: Array,
    item: Object,
  },
  computed: {
    date_item() {
      if (this.items) {
        return this.getDate(this.items)
      } else {
        return this.item
      }
    },
    urgent() {
      return this.date_item.dateTypeId  == 'U' || this.date_item.approvedPriority?.id == 'U'
    },
  }
}
</script>
